<template>
  <donut-chart34-template
    :board-ids="[480]"
    :data-type="dataType"
    field-code="public-transportation"
    :graph-id="76"
    title="(공중교통수단)안전·보건 확보 의무 현황"
    unit="건"
    :orientation="orientation"
  />
</template>

<script>
/* eslint-disable brace-style */
import DonutChart34Template from "@/views/graph/DonutChart34Template.vue";

export default {
  name: 'DonutChart76',
  components: {DonutChart34Template},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
}
</script>

<style scoped>

</style>
